(function(){

  // Only do this stuff if Modernizr reports that preserve3d *is* supported in the environment
  if (Modernizr.preserve3d) {

    var cards = document.querySelectorAll('.js-card');
    var resizeTimer = null;

    function setCardsHeight() {

      // For each card
      Array.prototype.forEach.call(cards, function(el) {

        // Determine card__front's top and bottom padding
        var cFront        = el.querySelector('.js-card__front');
        var cFrontStyle   = getComputedStyle(cFront);
        var cFrontPadding = parseFloat(cFrontStyle.paddingTop) + parseFloat(cFrontStyle.paddingBottom);

        // Determine the image's height
        var cImage        = el.querySelector('.js-card__image');
        var cImageHeight  = cImage.offsetHeight;

        // Determine the h2's height, including margin
        var cInfo         = el.querySelector('.js-card__info');
        var cInfoHeight   = cInfo.offsetHeight;
        var cInfoStyle    = getComputedStyle(cInfo);
        cInfoHeight       += parseFloat(cInfoStyle.marginTop) + parseFloat(cInfoStyle.marginBottom);

        // Add the three values together to determine the desired height
        var desiredHeight = cFrontPadding + cImageHeight + cInfoHeight;

        // Apply the desired height to the card
        el.style.height = desiredHeight + 'px';

      });

    }

    function resetCards() {

      // For each card
      Array.prototype.forEach.call(cards, function(el) {

        // Find its content element
        var cardContent = el.querySelector('.js-card__content');

        // Remove the is-flipped class from it
        cardContent.classList.remove('is-flipped');

      });

    }

    function flipCard() {

      // For each card
      Array.prototype.forEach.call(cards, function(el) {

        // Find its content element
        var cardContent = el.querySelector('.js-card__content');

        // When the card (not its content element) is clicked
        el.addEventListener('click', function() {

          // Reset all cards
          resetCards();

          // Toggle a class on its content element
          cardContent.classList.toggle('is-flipped');

        });

      });

    }

    function initCards() {

      // Set height of all cards
      setCardsHeight();

      // Prepare all cards for flipping
      flipCard();

    }

    window.onload = initCards;

    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        setCardsHeight();
      }, 250);
    });

  }

})();
